/**
 * Button Component
 * Primary interactive component with multiple variants
 */

import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  ...props
}) => {
  const baseStyles = 'font-medium rounded-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-[#128C7E] hover:bg-[#0F8070] text-white focus:ring-[#128C7E]',
    secondary: 'bg-[#1A1D23] hover:bg-[#252B33] text-white border border-[#2D3748] focus:ring-[#128C7E]',
    outline: 'border border-[#2D3748] text-[#A0AEC0] hover:text-white hover:border-[#128C7E] focus:ring-[#128C7E]',
    ghost: 'text-[#A0AEC0] hover:text-white hover:bg-[#1A1D23]/50 focus:ring-[#128C7E]',
  };

  const sizes = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-2.5 text-base',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-3.5 text-lg',
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
